import {
  select as d3Select,
  Selection as d3Selection,
  pie,
  arc,
  PieArcDatum,
} from "d3";
import React, { useLayoutEffect, useRef } from "react";
import styled from "styled-components";

const Styled = styled.div`
  user-select: none;
  display: flex;
  justify-content: center;
  svg {
    display: block;
  }
`;

export type PieChartProps = {
  data: number[];
  onClick?: (index: number) => void;
};

type PieDatum = {
  value: number;
  enabled: boolean;
};

const PieChart = (props: PieChartProps) => {
  const svgRef = useRef<SVGSVGElement>(null);

  useLayoutEffect(() => {
    if (!svgRef.current) return;

    const canvas = d3Select(svgRef.current);

    const decorateGraph = (
      selection: d3Selection<SVGSVGElement, unknown, null, undefined>,
    ) => {
      // d3 pie chart
      const pieGen = pie<PieDatum>().value((d) => d.value);
      const data = (
        Array.isArray(props.data) ? props.data.slice(0, 100) : []
      ).map((d) => ({
        value: 1,
        enabled: !!d,
      }));
      const data_ready = pieGen(data);

      const arcGen = arc<PieArcDatum<PieDatum>>()
        .innerRadius(0)
        .outerRadius(95);

      selection
        .selectAll("g.pie")
        .data([1])
        .join("g")
        .attr("class", "pie")
        .attr("transform", "translate(100, 100)")
        .selectAll("path")
        .data(data_ready)
        .join("path")
        .attr("data-cy", "slice")
        .attr("d", arcGen)
        .on("click", function () {
          const path = d3Select(this).interrupt();
          const { data, index } = path.datum() as PieArcDatum<PieDatum>;

          path.attr(
            "fill",
            data.enabled ? "rgb(109, 196, 236)" : "rgb(231, 231, 231)",
          );

          props.onClick?.(index);
        })
        .attr("fill", (d) => {
          return d.data.enabled ? "rgb(109, 196, 236)" : "rgb(231, 231, 231)";
        })
        .style("cursor", "pointer")
        .on("mouseover", function (event, d) {
          if (!d.data.enabled) {
            d3Select(this).transition().duration(200).attr("fill", "#dddddd");
          }
        })
        .on("mouseout", function (event, d) {
          if (!d.data.enabled) {
            d3Select(this).transition().duration(200).attr("fill", "#E7E7E7");
          }
        })
        .attr("aria-checked", (d) => {
          return d.data.enabled ? "true" : "false";
        })
        .attr("stroke", "rgb(51, 51, 51)")
        .attr("stroke-width", 1.25);
    };

    canvas.call(decorateGraph).select(".graph");
  });

  return (
    <Styled>
      <svg
        ref={svgRef}
        width={200}
        height={200}
        style={{ shapeRendering: "geometricPrecision" }}
      ></svg>
    </Styled>
  );
};

export default PieChart;
